import {HIDE_ERROR_MODAL} from './actionTypes';

export const hideErrorModalAction = () => {
  return {
    type: HIDE_ERROR_MODAL,
    payload: {      
      showErrorModal: false
    }
  }
}